'use client'

import { useContext } from 'react'

import DeviceInfoContext from '../contexts/device-info-context/device-info-context'

export enum DEVICE_TYPES {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export interface DeviceInfo {
  deviceType: DEVICE_TYPES
  isNativeView: boolean
  isTablet: boolean
}

const useDeviceInfo = () => {
  const { deviceInfo } = useContext(DeviceInfoContext)
  return deviceInfo
}

export default useDeviceInfo
